import React from 'react';
import styles from './text-editor.module.scss';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './text-editor.css';

const TextEditor = ({ label, required, onChange, value }) => {
  const handleChange = (content) => {
    onChange(content); // Calls parent function if needed
  };

  return (
    <div className={styles.container}>
        <p>
            {required ? '*' : null}
            <b>{label}</b>
        </p>
        <ReactQuill
            value={value} 
            onChange={handleChange} 
            theme="snow" 
        />
    </div>
  );
};

export default TextEditor;
